import { render, staticRenderFns } from "./footer-public.vue?vue&type=template&id=3e9f43a2&scoped=true&"
import script from "./footer-public.vue?vue&type=script&lang=js&"
export * from "./footer-public.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=3e9f43a2&scoped=true&lang=css&"
import style1 from "./footer-public.vue?vue&type=style&index=1&id=3e9f43a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f43a2",
  null
  
)

export default component.exports